import React from 'react';
import { connect } from 'react-redux';
import {Modal, Row, Col, Spin, Form, Button, InputNumber, message, Table} from 'antd';

import { Select, Input } from 'antd';
import { actions, updateAllAppList, asyncGet,updateAppList, } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;

class EditAppList extends React.Component {
    handleCancel = () => {
        this.props.modalHide();
        this.props.getTransferData({ selectedRowKeys: [] });
        this.props.getTransferDataApp({ selectedRowKeysApp: [] });
    };
    handleOk = () => {
        const { selectedRowKeys = [] } =this.props.transferData;
        const { selectedRowKeysApp = [] } =this.props.transferDataApp;
        if (!selectedRowKeys.length) {
            message.error('请选择目标客户端');
            return null;
        }
        /*if(!selectedRowKeysApp.length){
            message.error('请选择APP');
            return null;
        }*/
        let values ={};
        values.clientIdList = selectedRowKeys;
        let listApp = this.props.APPList;
        let apps =[];
        listApp.forEach(t => {
            if(selectedRowKeysApp.includes(t.key)){
                apps.push(t);
            }
        });
        values.appList=apps;
        this.props.updateAppList(formatFormData(values));
        this.props.modalHide();
        this.props.getTransferData({ selectedRowKeys: [] });
        this.props.getTransferDataApp({ selectedRowKeysApp: [] });
        this.props.asyncGet();
    };
    handleAllOk = () =>{
        const { selectedRowKeysApp = [] } =this.props.transferDataApp;
        if(!selectedRowKeysApp.length){
            message.error('请选择APP');
            return null;
        }
        let values ={};
        let listApp = this.props.APPList;
        let apps =[];
        listApp.forEach(t => {
            if(selectedRowKeysApp.includes(t.key)){
                apps.push(t);
            }
        });
        values.appList=apps;
        this.props.updateAllAppList(formatFormData(values));
        this.props.modalHide();
        this.props.getTransferData({ selectedRowKeys: [] });
        this.props.getTransferDataApp({ selectedRowKeysApp: [] });
        this.props.asyncGet();
    }
    onSelectChange = selectedRowKeysApp => {
        this.props.getTransferDataApp({ selectedRowKeysApp });
    }
    render() {
        const { APPList,udpateAppListShow, udpateVersionShow, item ,isUpdateAppListLoading} = this.props;
        const { getFieldDecorator } = this.props.form;
        const columns = [
            {
                title: 'appId',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'app名称',
                dataIndex: 'appName',
                key: 'appName',
            },
            {
                title: '包名称',
                dataIndex: 'packageName',
                key: 'packageName',
            },
            {
                title: 'channel',
                dataIndex: 'channel',
                key: 'channel',
            },
            {
                title: '版本',
                dataIndex: 'version',
                key: 'version',
            },
        ];
        const { selectedRowKeysApp } = this.props.transferDataApp;
        const rowSelection = {
            selectedRowKeysApp,
            onChange: this.onSelectChange,
        };
        return (
            <span>
                <Modal
                    width={800}
                    title="更新APP"
                    visible={udpateAppListShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isUpdateAppListLoading}
                    maskClosable={true}
                    closable = {false}
                    footer={[
                        <Button key="取消" onClick={this.handleCancel}>取消</Button>,
                        <Button key="更新全部" type="primary"  onClick={this.handleAllOk}>
                            更新全部
                        </Button>,
                        <Button key="更新选中" type="primary"  onClick={this.handleOk}>
                           更新选中
                        </Button>,          ]}
                >
                    <Spin spinning={isUpdateAppListLoading} tip="保存中...">
                        <Table
                            columns={columns}
                            dataSource={APPList}
                            defaultExpandAllRows={false}
                            rowSelection={rowSelection}
                            pagination={false}
                        />
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    isUpdateAppListLoading: state.clientList.uiStatus.isUpdateAppListLoading,
    udpateAppListShow: state.clientList.uiStatus.udpateAppListShow,
    transferDataApp: state.clientList.transferDataApp,
    transferData: state.clientList.transferData,
    APPList: state.clientList.APPList,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ udpateAppListShow: false })),
    updateAppList: contents => dispatch(updateAppList(contents)),
    asyncGet: () => dispatch(asyncGet()),
    getTransferDataApp: data => dispatch(actions.getTransferDataApp(data)),
    updateAllAppList: contents => dispatch(updateAllAppList(contents)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(EditAppList));



// WEBPACK FOOTER //
// ./pages/client/clientList/editAppList.js